import { render, staticRenderFns } from "./CtcFullReg.vue?vue&type=template&id=00c372b3&scoped=true"
import script from "./CtcFullReg.vue?vue&type=script&lang=js"
export * from "./CtcFullReg.vue?vue&type=script&lang=js"
import style0 from "./CtcFullReg.vue?vue&type=style&index=0&id=00c372b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c372b3",
  null
  
)

export default component.exports